import { useQuery } from '@hooks/reactQuery';

import { getKpiAlertVendorsStaticDropdown } from '@api/kpiAlerts';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { KPI_ALERT_VENDORS_DROPDOWN } from '@constants/queryKeys';

interface IUseQueryKpiAlertVendorsReturn {
	vendorsOptions: TSelectOptionType[];
	isLoading: boolean;
}

export const useQueryKpiAlertVendors = (): IUseQueryKpiAlertVendorsReturn => {
	const { data, isInitialLoading } = useQuery({
		queryKey: [KPI_ALERT_VENDORS_DROPDOWN],
		queryFn: getKpiAlertVendorsStaticDropdown,
		allowedRoles: [EUserRoles.networkOperatorKpiUpdater],
		select: (vendors) => mapDropdownOptions({
			items: vendors,
			valueKey: 'vendor.name',
			labelKey: 'vendor.title',
			additionalMappings: {
				isDefault: 'isDefault',
			},
		}),
		...refetchOptions,
	});

	return {
		vendorsOptions: data || [],
		isLoading: isInitialLoading,
	};
};
